import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalrequestabandonedphysical-card',
  templateUrl: './helpbutton-reports-totalrequestabandonedphysical-card.component.html',
  styleUrls: ['./helpbutton-reports-totalrequestabandonedphysical-card.component.scss']
})
export class HelpbuttonReportsTotalrequestabandonedphysicalCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
